<template>
    <div class="blog">
      <div class="mt-2">
        <router-link class="btn btn-primary" to="/postedit">Nuevo Post</router-link>
      </div>
      <post-listado class="mt-2"></post-listado>
        
    </div>
</template>

<script>

import fireApp from '../services/fireConfig.js'
import PostListado from './Post-Listado'


export default {
  name: 'blog',
  components: {
    PostListado
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Blog.vue?68ff1421